import { render } from "./ReportDesigner.vue?vue&type=template&id=43bfcdc3"
import script from "./ReportDesigner.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportDesigner.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/core/report/ReportDesigner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "43bfcdc3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('43bfcdc3', __exports__)) {
    console.log('reload')
    api.reload('43bfcdc3', __exports__)
  }
  
  module.hot.accept("./ReportDesigner.vue?vue&type=template&id=43bfcdc3", () => {
    console.log('re-render')
    api.rerender('43bfcdc3', render)
  })

}


export default __exports__